'use client'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import {
  ProductTierComparison,
  type ProductTierComparisonProps,
} from '@/components/ProductTierComparison/ProductTierComparison'
import type { ExpectedBlockType, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { filterByBlockType } from '@/services/storyblok/Storyblok.helpers'
import { storyblokEditable } from '@storyblok/react'
import { HeadingBlock, type HeadingBlockProps } from './HeadingBlock/HeadingBlock'

type Props = SbBaseBlockProps<
  Pick<ProductTierComparisonProps, 'coverageTextLabel' | 'caption'> & {
    title?: ExpectedBlockType<HeadingBlockProps>
    subtitle?: ExpectedBlockType<HeadingBlockProps>
  }
>

export function ProductTierComparisonBlock({ blok }: Props) {
  const titleBlock = filterByBlockType(blok.title, 'heading')
  const subTitleBlock = filterByBlockType(blok.subtitle, 'heading')

  let title = null
  if (titleBlock.length) {
    // That field is configured in storyblok to hold at the maximum 1 item
    title = <HeadingBlock blok={titleBlock[0]} nested={true} />
  }

  let subTitle = null
  if (subTitleBlock.length) {
    // That field is configured in storyblok to hold at the maximum 1 item
    subTitle = <HeadingBlock blok={subTitleBlock[0]} nested={true} />
  }

  return (
    <GridLayout.Root {...storyblokEditable(blok)}>
      <GridLayout.Content width={{ _: '1' }}>
        <ErrorBoundary>
          <ProductTierComparison
            title={title}
            subTitle={subTitle}
            coverageTextLabel={blok.coverageTextLabel}
            caption={blok.caption}
          />
        </ErrorBoundary>
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
